export default __webpack_public_path__ + "128338ef89960108c213d177ee6b3ae8.svg";